<template>
  <div>
    <CCard>
      <CCardHeader>
        <CampaignViewHeader
          title="Appendix III"
          :disable-member-select="!selected_member || is_loading"
          :selected-member-id="selected_member"
          :update-member-id-function="changeMember"
          showAmountInfo
        />
      </CCardHeader>
      <CCardBody>
        <DotsLoader v-if="is_loading"/>
        <template v-else>
          <CRow>
            <CCol col="3">
              <label>Code CPT:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="min-width: 200px"
                v-model="selected_code_cpt"
              />
            </CCol>
            <CCol col="3">
              <label>Code GTA:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="min-width: 200px"
                v-model="selected_code_gda"
              />
            </CCol>
            <CCol col="6" class="text-right">
              <CButton
                class="mz-button v2-mz-btn mr-2 mt-3"
                color="primary"
                @click="saveAnnexeIII"
              >
                {{ $t("Save") }}
              </CButton>
              <CButton
                class="mz-button v2-mz-btn mr-2 mt-3"
                color="primary"
                @click="
                  $downloadFile({
                    url: download_url
                  })
                ">
                {{ $t('Download') }}
              </CButton>
            </CCol>
          </CRow>
          <CRow class="mt-3" style="min-height: 80px">
            <CCol col="4" class="text-center header-cell table-style">
              {{ $t("Line of Business") }}
            </CCol>
            <CCol col="6">
              <CRow style="min-height: 40px">
                <CCol col="12" class="text-center header-cell table-style">
                  {{ $t("Year Y+1") }}
                </CCol>
              </CRow>
              <CRow style="min-height: 40px">
                <CCol col="4" class="text-center header-cell table-style">{{ $t("Number of polices") }}</CCol>
                <CCol col="4" class="text-center header-cell table-style">{{ $t("Estimated premiums") }}</CCol>
                <CCol col="4" class="text-center header-cell table-style">{{ $t("Gareat Rates in %") }}</CCol>
              </CRow>
            </CCol>
            <CCol col="2" class="text-center header-cell table-style">
              {{ $t("Gareat Premiums") }}
            </CCol>
          </CRow>
          <CRow
            v-for="row_data in table_rows"
            :key="row_data.line_of_business"
          >
            <CCol
              col="4"
              class="table-style data-row text-center"
              style="min-height: 60px"
            >
              {{ $t(row_data.line_of_business) }}
            </CCol>
            <CCol col="2" class="table-style data-row">
              <CInput
                :addInputClasses="addCustomClassToInput(row_data, 'police_number', 'issued_prime')"
                type="number"
                class="mt-2"
                :value="getNumericalValue(row_data.line_of_business === 'TOTAL' ? total_police_number : row_data.line_of_business === professional_string ? professional_police_number : row_data.police_number)"
                :disabled="row_data.line_of_business === 'TOTAL' || row_data.line_of_business === professional_string"
                @focusout="(e) => updateNumber(row_data, 'police_number', e)"
              />
            </CCol>
            <CCol col="2" class="table-style data-row">
              <CInput
                :addInputClasses="addCustomClassToInput(row_data, 'issued_prime', 'police_number')"
                type="number"
                class="mt-2"
                :value="getNumericalValue(row_data.line_of_business === 'TOTAL' ? total_issued_prime : row_data.line_of_business === professional_string ? professional_issued_prime : row_data.issued_prime)"
                :disabled="row_data.line_of_business === 'TOTAL' || row_data.line_of_business === professional_string"
                @focusout="(e) => updateNumber(row_data, 'issued_prime', e)"
              />
            </CCol>
            <CCol col="2" class="table-style data-row">
              <CInput
                addInputClasses="text-right"
                type="number"
                class="mt-2"
                v-if="row_data.line_of_business !== 'TOTAL' && row_data.line_of_business !== professional_string"
                :value="getNumericalValue(get_gareat_rate(row_data.line_of_business),2)"
                disabled
              />
            </CCol>
            <CCol col="2" class="table-style data-row">
              <CInput
                addInputClasses="text-right"
                type="number"
                v-if="row_data.line_of_business !== professional_string"
                class="mt-2"
                :value="getNumericalValue(row_data.line_of_business === 'TOTAL' ? total_mult / 100 : get_gareat_rate(row_data.line_of_business) * row_data.issued_prime / 100)"
                disabled
              />
            </CCol>
          </CRow>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import CampaignViewHeader from "@/components/CampaignViewHeader";
import {MemberService} from "../../services/members";
import {CampaignServices} from "../../services/campaigns";
import {AnnexIIIService, ANNEXIII_ENDPOINTS} from "../../services/annexiii";
import {getNumericalValue} from '@/utils/helpers';

export default {
  name: "AnnexeIIIView",
  components: {CampaignViewHeader},
  data() {
    return {
      getNumericalValue,
      professional_string: 'PROFESSIONAL PROPERTY DAMAGES including :',
      download_url: '',
      is_loading: true,
      members_options: [],
      selected_member: undefined,
      campaign_member: {},
      table_rows: [{
        line_of_business: 'MOTOR (exc liability)'
      }, {
        line_of_business: 'PERSONAL LINES'
      }, {
        line_of_business: 'PROFESSIONAL PROPERTY DAMAGES including :'
      }, {
        line_of_business: 'PROFESSIONAL  (Large Risks excluded)'
      }, {
        line_of_business: 'AGRICULTURAL (exc hail)'
      }, {
        line_of_business: 'OTHER PROPERTY DAMAGES'
      }, {
        line_of_business: 'AVIATION HULL < 1 million €'
      }, {
        line_of_business: 'NAV. HULL.PL < 1 million €'
      }, {
        line_of_business: 'TOTAL'
      }],
      total_lines_of_bussiness_to_sum: [
        'MOTOR (exc liability)', 'PERSONAL LINES',
        'PROFESSIONAL  (Large Risks excluded)',
        'AGRICULTURAL (exc hail)', 'OTHER PROPERTY DAMAGES',
        'AVIATION HULL < 1 million €', 'NAV. HULL.PL < 1 million €'
      ],
      professional_lines_of_bussiness_to_sum: [
        'PROFESSIONAL  (Large Risks excluded)',
        'AGRICULTURAL (exc hail)'
      ],
      gareat_rates: [],
    }
  },
  computed: {
    selected_code_cpt() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_cpt
    },
    selected_code_gda() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_gda
    },
    total_issued_prime() {
      return this.table_rows.reduce(
        (sum, row) => sum + Number(this.total_lines_of_bussiness_to_sum.includes(row.line_of_business) ? row.issued_prime : 0), 0
      )
    },
    total_mult() {
      return this.table_rows.reduce(
        (sum, row) => sum + Number(this.total_lines_of_bussiness_to_sum.includes(row.line_of_business) ? (row.issued_prime * this.get_gareat_rate(row.line_of_business)) : 0), 0
      )
    },

    total_police_number() {
      return this.table_rows.reduce(
        (sum, row) => sum + Number(this.total_lines_of_bussiness_to_sum.includes(row.line_of_business) ? row.police_number : 0), 0
      )
    },
    professional_police_number() {
      return this.table_rows.reduce(
        (sum, row) => sum + Number(this.professional_lines_of_bussiness_to_sum.includes(row.line_of_business) ? row.police_number : 0), 0
      )
    },
    professional_issued_prime() {
      return this.table_rows.reduce(
        (sum, row) => sum + Number(this.professional_lines_of_bussiness_to_sum.includes(row.line_of_business) ? row.issued_prime : 0), 0
      )
    },
  },
  async mounted() {
    this.is_loading = true
    const members = await MemberService.getMembers()
    this.members_options = members.map((member) => ({
      value: member.id_member,
      label: member.name,
      code_cpt: member.code_cpt,
      code_gda: member.code_gda,
    }));
    this.selected_member = Number(this.$route.params.id)
    this.download_url = ANNEXIII_ENDPOINTS.download_annexiii(
      this.$route.params.campaignId, this.$route.params.id)

    const {data} = await CampaignServices.fetchCampaignMember(this.$route.params.campaignId, this.$route.params.id)
    this.campaign_member = data
    const annexeiii_data = await AnnexIIIService.getAnnexIIIByCampaignMember(this.$route.params.campaignId, this.$route.params.id)
    this.table_rows = this.table_rows.map(row => {
      const found_annexeiii_data = annexeiii_data.find(annexeiii => row.line_of_business.includes(annexeiii.EN))
      return {
        ...row,
        EN: found_annexeiii_data?.EN,
        id_file: found_annexeiii_data?.id_file,
        gareat_prime: found_annexeiii_data?.gareat_prime || 0,
        police_number: found_annexeiii_data?.police_number || 0,
        issued_prime: found_annexeiii_data?.issued_prime || 0,
        taux: found_annexeiii_data?.taux || 0,
      }
    })
    
    const gareat_rates_data_dict = await AnnexIIIService.getAnnexIIIByCampaignMember(this.$route.params.campaignId, this.$route.params.id)
    const gareat_rates_data_list = Object.values(gareat_rates_data_dict);
    this.gareat_rates = this.table_rows.map(row => {
      const found_rate_data = gareat_rates_data_list.find(rate => row.line_of_business.includes(rate.EN))
      return {
        taux: found_rate_data?.taux || 0,
        branch: row.line_of_business
      }
    })

    this.is_loading = false
  },
  methods: {
    validRowSelectedAndNeighborValue(row_data, valid_row, valid_neighbor_row) {
      if (row_data.line_of_business === 'TOTAL' || row_data.line_of_business === this.professional_string) return
      return (row_data[valid_row] === 0 && row_data[valid_neighbor_row] > 0)
    },
    addCustomClassToInput(row_data, valid_row, valid_neighbor_row) {
      let classArr = ['text-right']
      if (this.validRowSelectedAndNeighborValue(row_data, valid_row, valid_neighbor_row)) classArr.push('validation-default')
      return classArr
    },
    hasWhiteSpace(s) {
      return /\s/g.test(s);
    },
    updateNumber(row_data, k, event) {
      let val = event.target.value
      if (typeof (val) === 'string' && this.hasWhiteSpace(val)) {
        val = val.replace(/\s+/g, '');
      }
      val = parseFloat(val)
      if (isNaN(val)) {
        row_data[k] = 0
      } else {
        row_data[k] = val
      }
    },
    changeMember(member_id) {
      this.$router.push({name: 'Appendix III', params: {campaignId: this.$route.params.campaignId, id: member_id}});
    },
    get_gareat_rate(line_of_business) {
      return this.gareat_rates.find(gareat_rate => gareat_rate.branch === line_of_business)?.taux || 0
    },
    validateAnnexeIIIData(annexeiii_data) {
      return !annexeiii_data.map(
        data => isNaN(parseFloat(data.issued_prime)) || isNaN(parseFloat(data.police_number))
      ).some(is_nan => is_nan)
    },
    async saveAnnexeIII() {
      const annexeiii_data = this.table_rows.filter(row => !!row.EN)
      if (!this.validateAnnexeIIIData(annexeiii_data)) {
        alert(this.$t("Table have to contain only numeric values"), {
            action: {
                text: this.$t('Close'),
                icon: 'close',
                onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                }
            }
        })

        return
      }
      await AnnexIIIService.createAnnexiii({
        annexeiii_data: annexeiii_data.map(data => ({
          ...data,
          issued_prime: parseFloat(data.issued_prime),
          police_number: parseFloat(data.police_number),
        })),
        id_campaign: this.$route.params.campaignId,
        id_member: this.$route.params.id,
      })
      alert(this.$t('Successfuly saved Appendix III data'), {
              action: {
                  text: this.$t('Close'),
                  icon: 'close',
                  onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                  }
              }
          })

    },
  }
}
</script>

<style>
.header-cell {
  border-width: 1px;
  border-style: solid;
  border-color: rgb(35, 20, 95);
}

.data-row {
  border-width: 1px;
  border-style: solid;
  border-bottom: rgb(35, 20, 95);
}

.table-style {
  background-color: #F3F4F3;
}

.arrow-buttons {
  display: none;
}
</style>
